// components/Banner.js
import React from 'react';
import { Box, Typography } from '@mui/material';

const Banner = () => (
  <Box
    sx={{
      backgroundColor: 'primary.dark',
      color: 'white',
      padding: 0.5,
      textAlign: 'center',
      boxShadow: 2,
    }}
  >
    <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
      Wir arbeiten gerade intensiv daran, Ihnen bald ein großartiges Erlebnis bieten zu können. 
      Besuchen Sie uns wieder - es lohnt sich!
    </Typography>
  </Box>
);

export default Banner;
